import React, { useEffect, useRef } from 'react';
import * as styles from './ContrastFocusVisibleContainer.scss';


interface ContrastFocusContainerProps {
    children: any;
    targetSelector?: (el: HTMLElement) => HTMLElement | null;
    className?: string;
}

export const ContrastFocusVisibleContainer = (props: ContrastFocusContainerProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const elementClickedRef = useRef<boolean>(false);

    const elementFocused = () => {
        if (containerRef.current && !elementClickedRef.current) {
            containerRef.current.classList.add(styles.focusVisible);
        }
    };

    const elementBlurred = () => {
        elementClickedRef.current = false;
        if (containerRef.current) {
            containerRef.current.classList.remove(styles.focusVisible);
        }
    };

    const elementClicked = () => {
        elementClickedRef.current = true;
        if (containerRef.current) {
            containerRef.current.classList.remove(styles.focusVisible);
        }
    };
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.addEventListener('mousedown', elementClicked);
            containerRef.current.addEventListener('focusin', elementFocused);
            containerRef.current.addEventListener('focusout', elementBlurred);

            return () => {
                if (containerRef.current) {
                    containerRef.current.removeEventListener('mousedown', elementClicked);
                    containerRef.current.removeEventListener('focusin', elementFocused);
                    containerRef.current.removeEventListener('focusout', elementBlurred);
                }
            };
        }
    }, []);
    return (
        <div
            className={`${styles.contrastFocusContainer} ${props.className ? props.className : ''}`}
            ref={containerRef}
        >
            {props.children}
        </div>
    );
};
